import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { getBlogs } from "@/lib/api";
import SectionTitle from "@/components/SectionTitle";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { getBlogs().then(setBlogs).catch(() => {}); }, []);

  const [featured, ...rest] = blogs;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="blog-page">
      <SectionTitle
        eyebrow="Health journal"
        title="Read, learn, live well."
        description="Practical health writing from our doctors — no jargon, no fear-mongering."
      />

      {featured && (
        <Link to={`/blog/${featured.slug}`} data-testid="featured-blog" className="group grid lg:grid-cols-2 gap-10 mb-20 items-center">
          <div className="aspect-[4/3] rounded-3xl overflow-hidden bg-[#E8ECE4]">
            <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-4">Featured · {featured.category}</div>
            <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight group-hover:text-brand-sage transition-colors">{featured.title}</h2>
            <p className="mt-5 text-brand-muted text-lg leading-relaxed">{featured.excerpt}</p>
            <div className="mt-6 text-sm text-brand-muted">By {featured.author} · {featured.read_time} min read · {featured.published_at}</div>
            <div className="mt-6 inline-flex items-center gap-2 text-brand-ink font-medium">Read article <ArrowRight size={16} /></div>
          </div>
        </Link>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {rest.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-tile-${b.slug}`} className="group flex flex-col">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl bg-[#E8ECE4] mb-5">
              <img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-brand-sage mb-3">{b.category} · {b.read_time} min</div>
            <h3 className="font-serif text-2xl text-brand-ink leading-tight group-hover:text-brand-sage transition-colors">{b.title}</h3>
            <p className="text-brand-muted text-sm mt-3 leading-relaxed">{b.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
